/**
 * ehr#571 (PROGRESS_NOTE_10-20-V141, V115): switching the template carries the writing across.
 * SOAP (or any template with Subjective and Objective) to DAP puts Subjective and Objective into an
 * empty Data box; DAP to SOAP puts Data into an empty Subjective (when Objective is empty too).
 * Nothing already typed in the new box is overwritten, and the old boxes keep their text.
 */
export function carryTemplateText(
  body: Record<string, string>,
  toKeys: readonly string[],
): Record<string, string> {
  const txt = (k: string) => (body[k] ?? '').trim();
  const next = { ...body };
  if (toKeys.includes('data') && !txt('data')) {
    const so = ['subjective', 'objective'].map(txt).filter(Boolean);
    if (so.length) next.data = so.join('\n\n');
  }
  if (toKeys.includes('subjective') && !txt('subjective') && !txt('objective') && txt('data'))
    next.subjective = txt('data');
  return next;
}
